/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 708);
/******/ })
/************************************************************************/
/******/ ({

/***/ 708:
/***/ (function(module, exports) {

var HEADER_ID = 'tv-header';
var FOOTER_ID = 'tv-footer';

var OS_BLOCK_ACTIVE_CLASS = 'info-for-OSBlock__title-with-icon--active';
window.toggleOSBlockDetails = function (event) {
	return event.currentTarget.classList.toggle(OS_BLOCK_ACTIVE_CLASS);
};
window.closeOSBlockDetails = function (event) {
	return event.currentTarget.parentElement.previousElementSibling.classList.remove(OS_BLOCK_ACTIVE_CLASS);
};

/**
 * IE11 NodeList.forEach() polyfill
 */
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

var domReady = function domReady() {

	var userAgent = navigator.userAgent || navigator.vendor || window.opera;

	var isAndroid = /android/i.test(userAgent) && /wv/i.test(userAgent);
	var isIos = /ipad|iphone/.test(userAgent) && /mediafirst/i.test(userAgent) || /iPad|iPhone/.test(userAgent);
	// Display header and footer if it's not an iPhone or iPad
	if (!isIos) {
		var header = document.getElementById(HEADER_ID);
		var footer = document.getElementById(FOOTER_ID);

		if (header) {
			header.style.display = 'block';
		}

		if (footer) {
			footer.style.display = 'block';
		}
	}

	var isAndroidDisabled = isAndroid && window.disableAndroid;
	var isIosDisabled = isIos && window.disableIos;

	if (isAndroidDisabled || isIosDisabled) {
		if (isIosDisabled) {
			document.querySelectorAll('[data-ios-prevent-default=""]').forEach(function (element) {
				element.addEventListener('click', function (event) {
					event.preventDefault();
					return false;
				});
			});
		}
		document.querySelectorAll('a[data-instead-of-registration=""]').forEach(function (element) {
			element.classList.add('show-button');
		});
		var infoBox = document.querySelector('.info-for-OSBlock');
		if (infoBox && infoBox.style) infoBox.style.display = 'block';
	} else {
		document.querySelectorAll('a[data-registration-button=""]').forEach(function (element) {
			element.classList.add('show-button');
		});

		if (document.getElementById('header-login-button')) {
			document.getElementById('header-login-button').insertAdjacentHTML('afterend', '<a class="btn" href="/portal/regisztraciok">Regisztráció</a>');
		}
	}
	/**
  * Galaxy Note10+on ugorjon egy kicsit feljebb az input, ha épp focusálunk benne
  */
	var GALAXY_NOTE10PLUS_SIZE = {
		width: 412,
		height: 869
	};
	if (/android/i.test(userAgent) && GALAXY_NOTE10PLUS_SIZE.width == screen.width && GALAXY_NOTE10PLUS_SIZE.height == screen.height) {
		var htmlOrBody = document.querySelector('html') || document.querySelector('body');
		var inputElement = document.querySelector('input');
		var scrollTopPadding = 8;
		var scrollTopLast = 0;

		inputElement.addEventListener('focus', function (el) {
			scrollTopLast = htmlOrBody.scrollTop;
			var textareaTop = el.offsetTop;
			window.scrollBy({ top: textareaTop - scrollTopPadding, left: 0, behavior: 'smooth' });
		});

		inputElement.addEventListener('blur', function () {
			htmlOrBody.scrollTo(0, scrollTopLast);
		});
	}

	window.goToLink = function (event) {
		if (/ipad|iphone/i.test(userAgent)) {
			event.preventDefault();
			return false;
		}
	};
};

document.addEventListener('DOMContentLoaded', domReady);

/***/ })

/******/ });


// WEBPACK FOOTER //
// layouts/utils.js